import type {
  TranslateNumberFormatOptions,
  TranslateNumberValue,
} from "./translate-number.type";

import { useGetSettingsLocale } from "@/entities/settings";

import { translateNumber } from "./translate-number.helper";

export const useTranslateNumber = () => {
  const locale = useGetSettingsLocale();

  const _translateNumber = (
    value: TranslateNumberValue,
    formatOptions?: TranslateNumberFormatOptions
  ) => {
    return translateNumber(value, { locale, ...formatOptions });
  };

  return {
    translateNumber: _translateNumber,
  };
};
